import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './TopNav.css';

function TopNav() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="topnav">
      <div className="topnav_inner">
        <Link className="topnav_brand" to="/" onClick={handleLinkClick}>
          DevLab
        </Link>

        <button
          type="button"
          className={`topnav_toggle ${menuOpen ? 'is-open' : ''}`}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          onClick={handleToggle}
        >
          <span />
          <span />
          <span />
        </button>

        <ul className={`topnav_links ${menuOpen ? 'is-open' : ''}`}>
          <li>
            <NavLink to="/" end onClick={handleLinkClick}>
              Home
            </NavLink>
          </li>
          <li>
            <Link to="/#services" onClick={handleLinkClick}>
              Services
            </Link>
          </li>
          <li>
            <NavLink to="/about" onClick={handleLinkClick}>
              About
            </NavLink>
          </li>
          <li>
            <Link to="/#contact" onClick={handleLinkClick}>
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default TopNav;
